import React from "react";
import { MainContainer } from "../../components/ContentWrapper";
import { PageTitle } from "../../components/PageTitle";
import { ReactComponent as VideoIcon } from "../../assets/svg/icon-video.svg";
import { ReactComponent as HelpIcon } from "../../assets/svg/icon-help-circle.svg";
import { ReactComponent as BulbIcon } from "../../assets/svg/bulb.svg";
import { TUTORIAL_VIDEOS, GETTING_STARTED_FAQS, SUPPORT_EMAIL } from "../expertResources/helper";
import { FaqList } from "../../components/FaqList/FaqList";
import { VideoGrid } from "../../components/VideoGrid/VideoGrid";

export default function TutorialsList() {
    return (
        <MainContainer>
            <div className="flex flex-col gap-6">
                <PageTitle title="Tutorials" />

                <div className="w-full flex flex-col" style={{ fontFamily: "'CircularStd', 'DM Sans', sans-serif" }}>
                    <section className="py-5">
                        <div className="flex items-center gap-2.5 mb-3.5 text-sm font-semibold text-text-1 [&>svg]:text-accent [&>svg]:shrink-0">
                            <VideoIcon width={22} height={22} />
                            Videos
                        </div>
                        <VideoGrid videos={TUTORIAL_VIDEOS} />
                    </section>

                    <div className="h-px bg-border-token" />

                    <section className="py-5">
                        <div className="flex items-center gap-2.5 mb-3.5 text-sm font-semibold text-text-1 [&>svg]:text-accent [&>svg]:shrink-0">
                            <BulbIcon width={22} height={22} />
                            Getting Started
                        </div>
                        <FaqList items={GETTING_STARTED_FAQS} />
                    </section>

                    <div className="h-px bg-border-token" />

                    <section className="py-5">
                        <div className="flex items-center gap-2.5 mb-3.5 text-sm font-semibold text-text-1 [&>svg]:text-accent [&>svg]:shrink-0">
                            <HelpIcon width={22} height={22} />
                            Need more help?
                        </div>
                        <div className="flex items-center gap-4 px-4 py-4 bg-surface-2 border border-border-token rounded-xl flex-col sm:flex-row sm:items-center">
                            <div className="flex-1 min-w-0 w-full">
                                <div className="text-sm font-semibold text-text-1 mb-0.5">Contact support</div>
                                <div className="text-[13px] text-text-2">Having trouble? Reach out to our team for assistance.</div>
                            </div>
                            <a
                                href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent("Support request from the portal")}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent("Support request from the portal")}`;
                                }}
                                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-accent text-white text-[13px] font-semibold no-underline whitespace-nowrap transition-colors hover:bg-[#B8956A] cursor-pointer"
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                    <polyline points="22,6 12,13 2,6" />
                                </svg>
                                Email us
                            </a>
                        </div>
                    </section>
                </div>
            </div>
        </MainContainer>
    );
}
